import { ScrollText, Shield } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Trust() {
    const privacyLink = process.env.NEXT_PUBLIC_PRIVACY_POLICY_URL;
    const termsLink = process.env.NEXT_PUBLIC_TERMS_OF_SERVICE_URL;

    return (
        <>
            <div className="flex flex-row gap-2 flex-shrink-0 rounded-xl p-3 border border-border-300 justify-start">
                <Shield
                    size={16}
                    className="shrink-0 mt-1 text-[#717182]"
                />
                <div className="flex flex-col gap-2">
                    <h4 className="font-semibold text-base text-[#717182]">
                    Required by Law
                    </h4>
                    <p className="text-sm leading-6 text-[#717182]">
                    Identity verification is required for compliance
                    with anti-money laundering (AML) and
                    know-your-customer (KYC) regulations.
                    </p>
                </div>
            </div>
            <div className="flex flex-row gap-2 flex-shrink-0 rounded-xl p-3 border border-border-300 justify-start">
                <ScrollText
                    size={16}
                    className="shrink-0 mt-1 text-[#717182]"
                />
                <div className="flex flex-col gap-2">
                    <h4 className="font-semibold text-base text-[#717182]">
                    Licensed Service Providers
                    </h4>
                    <p className="text-sm leading-6 text-[#717182]">
                    We partner with multiple licensed and regulated
                    service providers to securely process your
                    verification.
                    </p>
                </div>
            </div>
            <div className="flex flex-col gap-2 flex-shrink-0 rounded-xl p-3 border border-border-300 justify-start">
                <p className="text-sm leading-6 text-[#717182]">
                    Your data is used solely for identity verification
                    purposes. We are committed to protecting your privacy
                    and data security.
                </p>
                <div className="flex flex-row gap-2">
                    <Button variant="link" asChild className="px-0">
                        <a
                            href={privacyLink}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Privacy Policy
                        </a>
                    </Button>
                    <Button variant="link" asChild className="px-0">
                        <a
                            href={termsLink}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Terms of Service
                        </a>
                    </Button>
                </div>
            </div>
        </>
    )
}